export function formatResponseCode(inputString: string | null): string {
  if (!inputString) {
    return '';
  }

  // Replace dashes with spaces
  const stringWithSpaces = inputString.replace(/-/g, ' ');

  // Split the string into words, proper case each word, and join them back
  return stringWithSpaces
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
